/**
 * Form Registry
 *
 * Provides mappings from SettingsCategory to their corresponding form components
 * and display labels. Used for dynamic form rendering in settings modals and pages.
 */

import type React from "react";
import type { SettingsCategory } from "../types/settings";
import { ProfileForm } from "../pages/ProfileForm";
import { InvestableAssetsForm } from "../pages/InvestableAssetsForm";
import { RealEstateAssetsForm } from "../pages/RealEstateAssetsForm";
import { LiabilitiesForm } from "../pages/LiabilitiesForm";
import { IncomeForm } from "../pages/IncomeForm";
import { ExpensesForm } from "../pages/ExpensesForm";
import { AssumptionsForm } from "../pages/AssumptionsForm";

/**
 * Map from SettingsCategory to the corresponding React form component
 */
export const FORM_COMPONENTS: Record<SettingsCategory, React.ComponentType> = {
  profile: ProfileForm,
  investableAssets: InvestableAssetsForm,
  realEstateAssets: RealEstateAssetsForm,
  liabilities: LiabilitiesForm,
  income: IncomeForm,
  expenses: ExpensesForm,
  assumptions: AssumptionsForm,
};

/**
 * Map from SettingsCategory to its display label string
 */
export const CATEGORY_LABELS: Record<SettingsCategory, string> = {
  profile: "Profile",
  investableAssets: "Investable Assets",
  realEstateAssets: "Real Estate & Other Assets",
  liabilities: "Liabilities",
  income: "Income",
  expenses: "Expenses",
  assumptions: "Assumptions",
};
